var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTypes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.561 14.905H5.913v1.703h-.859V12.44h2.713v.695H5.913v1.076H7.56v.693ZM9.178 16.608h-.859V12.44h.859v4.167ZM10.835 15.918h1.823v.69H9.976V12.44h.859v3.477ZM15.66 14.802H14.01v1.116h1.935v.69h-2.793V12.44h2.787v.695h-1.929v.993h1.649v.673Z",
  fill: "#64748B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.767 6.712V4.501l2.655 2.575h-2.297c-.235-.019-.366-.205-.358-.364Z",
  fill: "#64748B",
  stroke: "#64748B",
  strokeWidth: 1.6
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.967 4.662a2.2 2.2 0 0 1 2.2-2.2h7.911a2.2 2.2 0 0 1 1.688.789l2.755 3.295a2.2 2.2 0 0 1 .512 1.411v9.038a2.2 2.2 0 0 1-2.2 2.2H5.167a2.2 2.2 0 0 1-2.2-2.2V4.662Z",
  stroke: "#64748B",
  strokeWidth: 1.6
})));
export default SvgTypes;